module.exports = __webpack_public_path__ + "img/idxGame05_btn.4f1df69.webp";